import * as React from 'react';

import { CustomPortal } from '../custom-portal/custom-portal.tsx';

import { useClickAway } from '../hooks.tsx';

import './overlay.css';

interface OverlayProps extends React.HTMLAttributes<HTMLDivElement> {
  onClose: () => void;
  isOpen: boolean;
  id: string;
}

const Overlay = React.forwardRef<HTMLDivElement, OverlayProps>(
  ({ onClose, isOpen, id, children, ...props }, ref) => {
    const modalRef = useClickAway(() => {
      onClose();
    });

    React.useEffect(() => {
      const closeOnEscapeKey = (e: KeyboardEvent) => {
        e.key === 'Escape' ? onClose() : null;
      };

      document.body.addEventListener('keydown', closeOnEscapeKey);

      return () => {
        document.body.removeEventListener('keydown', closeOnEscapeKey);
      };
    }, [onClose]);

    if (!children) return;

    return (
      <CustomPortal wrapperId={id}>
        {isOpen && (
          <div className="overlay" ref={ref} {...props}>
            <div className="overlay-content" ref={modalRef}>
              {children}
            </div>
          </div>
        )}
      </CustomPortal>
    );
  },
);

export { Overlay };
